import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './plugins/router'
import store from '@/store'
import VueSimpleMarkdown from 'vue-simple-markdown'
import 'leaflet/dist/leaflet.css';
import Cfplugin from './plugins/cf_api'
import AuthPlugin from './plugins/cf_auth'
import configplugin from '@/plugins/config'
//import {HubConnectionBuilder} from '@microsoft/signalr'

import { vuexOidcCreateStoreModule} from 'vuex-oidc'

Vue.config.productionTip = false
Vue.prototype.$config =store.getters.getConfig

const cfPlugin = {
  install () {
    Vue.cf_api = Cfplugin
    Vue.prototype.$cf_api = Cfplugin
  }
}
/*const signalRPlugin = {
  install () {
    Vue.signal_r = HubConnectionBuilder
    Vue.prototype.$signal_r = HubConnectionBuilder
  }
}/**/
const authPlugin = {
  install () {
    Vue.cf_auth = AuthPlugin
    Vue.prototype.$cf_auth = AuthPlugin
  }
}

configplugin.getConfig().then(response => {
  console.log('main.js', response)
  Vue.prototype.$config=response
  store.state.config =  response
  store.dispatch('configureOidcAuth')
  if(!store.hasModule('oidcStore')){
    store.registerModule("oidcStore",vuexOidcCreateStoreModule(store.state.oidcSettings,{ namespaced: false, publicRoutePaths: ['/', '/redirect'] },{
        userLoaded: (user) => console.log('OIDC user is loaded:', user),
        userUnloaded: () => console.log('OIDC user is unloaded'),
        accessTokenExpiring: () => console.log('Access token will expire'),
        accessTokenExpired: () => console.log('Access token did expire'),
        silentRenewError: () => console.log('OIDC user is unloaded'),
        userSignedOut: () => console.log('OIDC user is signed out'),
        oidcError: (payload) => console.log(`An error occured at ${payload.context}:`, payload.error),
        automaticSilentRenewError: (payload) => console.log('Automatic silent renew failed.', payload)
      })
    )
  }
  Vue.use(cfPlugin)
  Vue.use(authPlugin)
  //Vue.use(signalRPlugin)
  Vue.use(VueSimpleMarkdown)
  new Vue({
    store,
    vuetify,
    router,
    render: h => h(App)
  }).$mount('#app')
});

/*

Vue.use(cfPlugin)
Vue.use(authPlugin)
Vue.use(VueSimpleMarkdown)
new Vue({
  store,
  beforeMount() {
    this.$store.dispatch('setConfig');
  },
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
/**/